import ActionTypes from "./actionTypes";

export const toggleEditing = (enabled: boolean) => {
	return { type: ActionTypes.EDIT_TOGGLE, enabled };
};

export const editPanelToggle = (instance: string) => {
	return { type: ActionTypes.EDIT_PANEL_TOGGLE, instance };
};

export const editLayoutToggle = (enabled: boolean) => {
	return { type: ActionTypes.EDIT_LAYOUT_TOGGLE, enabled };
};

export const editChangesIncrement = () => {
	return (dispatch) => {
		dispatch({ type: ActionTypes.EDIT_CHANGES_INCREMENT });
		return Promise.resolve();
	};
};

export interface IActiveArgs {
	type: "panel" | "view";
	id?: string;			// view or panel registered id
	instance: string;		// view variant instance or panel instance
	dialog?: boolean;
}

export const editSetActive = (active: IActiveArgs | null) => {
	return { type: ActionTypes.EDIT_ACTIVE_SET, active };
};

export const editClearActive = () => {
	return { type: ActionTypes.EDIT_ACTIVE_SET, active: null };
};



// WEBPACK FOOTER //
// ./src/core/actions/editActions.ts